import moment from '@/core/moment-config'

export default function (value) {
  if (value === undefined || value === null) {
    return null
  }
  return moment(value).format('HH:mm')
}
